export default __webpack_public_path__ + "static/media/inspirationHorse.d29b7ed9.png";